import React from 'react';

import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { useYAxes } from '@mui/x-charts/hooks';
import { AxisId } from 'ff/debrief/models';

interface Props {
    rightAxisId: AxisId;
}

/**
 * Because of a bug in MUI X we need to wrap the right axis. When you pass
 * `axisId` to `ChartsYAxis` it will try to index the yAxis object with that id.
 * However, for some reason the object is not populated with the updated list
 * of yAxes IDs on every render. So we need to wait for that object to have a
 * property that matches the current right-side axisId.
 * @param props
 * @constructor
 */
const RightYAxisWrapper = (props: React.PropsWithChildren<Props>) => {
    const { yAxis } = useYAxes();
    if (yAxis[props.rightAxisId]) {
        return (
            <ChartsYAxis
                axisId={props.rightAxisId}
                tickLabelStyle={{
                    textAnchor: 'end',
                }}
                disableLine
                disableTicks
            />
        );
    } else {
        return null;
    }
};

export default RightYAxisWrapper;
